query GetPermissions {
  permissions {
    id
    name
    permissionType
  }
}
